import { useCallback } from 'react';
import { useRxData } from 'rxdb-hooks';

import { isJestTest } from '../../test-helpers/isJestTest';
import { Discipline } from '../../utilities/enums';
import { getValueFromLocalStorage } from '../../utilities/utilityFunctions';
import useAssetDetails from '../assetDetails/useAssetDetails';
import { RxdbCollectionName } from '../rxdbCollectionName';
import { ComponentType, ComponentTypeCollection } from './queryBuilder';

const useComponentType = (discipline: number) => {
  const { result: assetDetails } = useAssetDetails();
  const getComponentTypeQuery = useCallback(
    (collection: ComponentTypeCollection) => {
      const selector =
        discipline === Discipline.Shaft
          ? { discipline }
          : {
              assetCategory: isJestTest()
                ? Number(getValueFromLocalStorage('assetCategoryId'))
                : assetDetails?.assetCategoryId,
            };
      return collection?.find({ selector });
    },
    [discipline, assetDetails],
  );

  const { result: componentTypeListData } = useRxData<ComponentType>(
    RxdbCollectionName.COMPONENT_TYPE,
    getComponentTypeQuery,
    { json: true },
  );

  return { componentTypeListData };
};

export default useComponentType;
